/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Error returned when no active index exists for the project and ref.
 */
export interface InlineObject { 
    status: number;
    message: string;
    timestamp: string;
    error: string;
    path: string;
    /**
     * Technical lifecycle state of the searched index. READY means an active index exists and no reindex is open. INDEXING means a reindex is pending or running; an existing active index remains searchable. NOT_INDEXED means neither an active index nor an open reindex exists. 
     */
    indexState: InlineObject.IndexStateEnum;
    /**
     * Stable reason code for a missing active index.
     */
    code: InlineObject.CodeEnum;
}
export namespace InlineObject {
    export const IndexStateEnum = {
        Ready: 'READY',
        Indexing: 'INDEXING',
        NotIndexed: 'NOT_INDEXED'
    } as const;
    export type IndexStateEnum = typeof IndexStateEnum[keyof typeof IndexStateEnum];
    export const CodeEnum = {
        IndexNotReady: 'INDEX_NOT_READY'
    } as const;
    export type CodeEnum = typeof CodeEnum[keyof typeof CodeEnum];
}


